module.exports = __webpack_public_path__ + "dd361ce5e5a9fa95e0efae904370958a.svg";